import React from 'react';
import { ChevronRightIcon, HomeIcon } from 'lucide-react';
interface BreadcrumbItem {
  label: string;
  href?: string;
}
interface BreadcrumbProps {
  items: BreadcrumbItem[];
}
export const Breadcrumb = ({
  items
}: BreadcrumbProps) => {
  return <nav className="flex" aria-label="Breadcrumb" data-id="element-208">
      <ol className="inline-flex items-center space-x-1 md:space-x-3" data-id="element-209">
        <li className="inline-flex items-center" data-id="element-210">
          <a href="#" className="inline-flex items-center text-gray-500 hover:text-gray-700" data-id="element-211">
            <HomeIcon className="w-4 h-4 mr-2" data-id="element-212" />
            Inicio
          </a>
        </li>
        {items.map((item, index) => <li key={index} data-id="element-213">
            <div className="flex items-center" data-id="element-214">
              <ChevronRightIcon className="w-4 h-4 text-gray-400" data-id="element-215" />
              {item.href ? <a href={item.href} className="ml-1 text-gray-500 hover:text-gray-700 md:ml-2" data-id="element-216">
                  {item.label}
                </a> : <span className="ml-1 text-gray-700 md:ml-2" data-id="element-217">{item.label}</span>}
            </div>
          </li>)}
      </ol>
    </nav>;
};